import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import moment from "moment";

const StepGradOptions = ({ myInitInfo, setMyInitInfo, gradeCodes, isPrimePedcCd }) => {
    return (
        <FormGroup>
            <Label className="conlabel">
                1. 학년을 선택하세요.<span>({moment().format("YYYY")}년도 기준으로 선택)</span>
            </Label>
            {gradeCodes.map((info, idx) => (
                <FormGroup key={idx} check className="d_inb">
                    <Input
                        type="radio"
                        name="radio-grade"
                        id={"grade" + idx}
                        value={info.CD}
                        checked={myInitInfo.gradCd === info.CD}
                        onChange={(e) => {
                            setMyInitInfo({
                                ...myInitInfo,
                                gradCd: e.target.value,
                            });
                        }}
                    />
                    <Label check htmlFor={"grade" + idx}>
                        <span className="icon" />
                        {info.CD === "GR20" &&
                        (moment().month() < 5 || (moment().month() === 5 && moment().date() <= 29))
                            ? `${info.CD_NM}(초6)`
                            : info.CD_NM}
                    </Label>
                </FormGroup>
            ))}
            {isPrimePedcCd && (
                <p className="prime-grade-notice">
                    *예비중(중1)/고등과정의 경우 학년 임의 설정 후 교사가 LMS에서 변경할 수 있습니다.
                </p>
            )}
        </FormGroup>
    );
};
export default StepGradOptions;
